import { TranslatedTextSchema } from "./TranslatedText";
import { z } from "zod";

export type AsyncTranslationResult = z.infer<typeof AsyncTranslationResultSchema>;
export const AsyncTranslationResultSchema = z.object({
  success: z.boolean(),
  translated_text: z.array(TranslatedTextSchema),
});
